/* eslint-disable no-undef */
import MapDeleteButtonOverlay from 'js/components/map/MapDeleteButtonOverlay';
import MapHelper from 'js/helpers/MapHelper';

const CircleDeleteButton = ({ shape, map, onClick }) => {
    const center = shape?.getCenter();
    const radius = shape?.getRadius();

    const getPixelPosition = (divPosition, offsetX, offsetY) => {
        const radiusInPixel = MapHelper.convertMetersToPixels(radius, map.getZoom(), center.lat());
        return {
            x: divPosition.x - offsetX,
            y: (divPosition.y + radiusInPixel) - offsetY
        };
    };

    return (
        <MapDeleteButtonOverlay
            map={map}
            position={center}
            onClick={onClick}
            getPixelPosition={getPixelPosition}
        />
    );
};

export default CircleDeleteButton;
